// import Web from "./web";
import Mobile from "./mobile";

const Header = ({ headerWeb, headerMob, showIcon }) => {
  return (
    <>
      <header className="header-main">
        <div className="container-main d-none d-lg-block">
          {headerWeb ? (
            <Mobile header={headerMob} showIcon={showIcon} />
          ) : (
            false
          )}
        </div>
        <div className="container-main d-block d-lg-none">
          {headerMob ? <Mobile header={headerMob} showIcon={showIcon} /> : false}
        </div>
      </header>
    </>
  );
};

export default Header;
